import React from 'react'
import MuiSwitch from '@mui/material/Switch'

const defaultSx = {
  width: '40px',
  height: '24px',
  padding: 0,
  margin: '8px',
  marginLeft: 0,

  '& .MuiSwitch-switchBase': {
    padding: '2px',
        '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: '#ffffff',
            '& + .MuiSwitch-track': {
                backgroundColor: '#1daeec',
                opacity: 1,
                border: 'none',
            },
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: '#52d869',
            border: '6px solid #fff',
        },
  },

  '& .MuiSwitch-thumb': {
    height: '20px',
    width: '20px',
  },

  '& .MuiSwitch-track': {
    borderRadius: '12px',
    border: 0,
    backgroundColor: '#cccccc',
    opacity: 1,
  },

  checked: {},
  focusVisible: {},
}

export interface SwitchProps {
  checked: boolean
  disabled?: boolean
  onChange?: Function
  sx?: object
}

/**
 * @param {SwitchProps} props
 * @param {boolean} props.checked - specifies whether Switch should be set to "on" pr "off" position
 * @param {boolean} props.disabled (Optional) - specifies whether Switch should be disabled 
 * @param {Function} props.onChange (Optional) - specifies handler to be called when the switch is toggled
 * @param {object} props.sx (Optional) - To customize the look and feel if needed.
 */

const Switch = ({ 
  checked, 
  onChange,
  disabled,
  sx,
}: SwitchProps) => {

  const handleChange = (event: React.ChangeEvent<HTMLElement>) => {
    onChange && onChange(event)
  }

  return (
    <MuiSwitch
      sx={{ ...defaultSx, ...sx }}
      focusVisibleClassName={'.Mui-focusVisible'}
      disableRipple
      checked={Boolean(checked)}
      onChange={handleChange}
      disabled={Boolean(disabled)}
    />
  )
}

Switch.defaultProps = {
  checked: false,
  disabled: false,
  onChange: () => null,
}

export default Switch
